<template>
  <div class="row" id="movie">
    <b-modal size="lg" id="modal-1" :title="title">
      <div class="col-12 text-center">
        <youtube :video-id="videoId" ref="youtube"></youtube>
      </div>
    </b-modal>
    <transition-group
      name="list"
      tag="ul"
      mode="in-out"
      class="col-12 ml-0 mr-0 pl-0 pr-0"
    >
      <b-list-group-item v-for="(item, index) in items" :key="item.id" class>
        <!-- <div v-if="index==items.length/2">sss</div> -->
        <div class="list-item col-12 li-border mt-1 mt-md-3">
          <div class="row movie-row">
            <div class="col-1 col-md-1 p-0">
              <div class="text-center2 p-0 text-center">
                <h6 class="text-white mb-0 pb-0">{{ ++index }}</h6>
              </div>
            </div>

            <!-- <div
              @click="openYoutob(item.trailer.video)"
              style="cursor: pointer"
              class="col-3 p-0 pr-md-5 col-md-2 text-center image-heghit text-center2 h-100 py-2"
            > -->

            <div
              class="imageFather col-3 p-0 pr-lg-5 col-md-2 text-center image-heghit text-center2 h-100 py-2 postion-relative"
            >
              <img
                loading="lazy"
                :src="item.poster"
                class="mt-1 rounded-8px my-2 mb-1 image"
                v-if="item.poster"
              />
              <img
                loading="lazy"
                v-else
                src="https://tidewaterpro.com/application/modules/themes/views/default/assets/images/image-placeholder.png"
                class="mt-1 my-2 rounded-8px mb-1 image"
              />
              <!-- <button v-b-modal.modal-1  class="position-absolute wahtch-trailer btn btn-dark px-1 px-lg-4 px-md-3" ><small class="text-nowrap">watch trailer</small></button> -->
            </div>
            <!-- <transition name="fade" mode="out-in"> -->
            <div class="col-6 col-md-7">
              <div class="text-center2">
                <h5 class="text-white">{{ item.title }}</h5>
                <!-- <transition name="fade" mode="out-in"> -->
                <!-- <div class="col-12"> -->
                <strong class="row" :key="item.id">
                  <div class="col-12 mt-md-3">
                    <span class="text-success col-md-4 pl-0 flex-between">
                      <p class="text-muted m-0 watches">Watch :</p>
                      {{ item.stats.up_votes }}
                    </span>
                  </div>
                  <div class="col-12 mt-md-2">
                    <span class="text-danger col-md-4 pl-0 flex-between">
                      <p class="text-muted text-nowrap m-0 watches">
                        Dont Watch :
                      </p>
                      {{ item.stats.down_votes }}
                    </span>
                  </div>
                  <!-- <div class="col-12 mt-md-2">
                    <span class="text-colden col-md-4 pl-0 flex-between">
                      <img width="40px" height="20px" src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/IMDB_Logo_2016.svg/250px-IMDB_Logo_2016.svg.png"/>
                      
                      {{ item.rates.imdb }} 
                    </span>
                  </div> -->
                </strong>
                <!-- </div> -->
                <!-- </transition> -->
              </div>
            </div>
            <div class="col-2 col-md-2 mt-1 alighcenter">
              <div class="row voter">
                <div class="col-lg-6 col-md-10 offset-md-1 offset-lg-3">
                  <svg
                    v-if="item.me.vote == 1"
                    @click="vote(item.id, 0, item)"
                    width="93%"
                    viewBox="0 0 100 97"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>Clip 2</title>
                    <defs>
                      <path
                        d="M74.3721879,60.258774 L75.2842648,86.9536377 L49.9999971,77.8466845 L24.7157371,86.9536377 L25.6278025,60.258774 L9.09090731,39.198083 L34.9386134,31.8048142 L49.9999971,9.68093092 L65.0613808,31.8048142 L90.9090716,39.198083 L74.3721879,60.258774 Z M96.3916481,33.440391 L69.6874575,25.7673915 L54.1516123,2.81243133 C53.7846507,2.25750829 53.31442,1.7879314 52.7943046,1.45000834 C51.693497,0.702969924 50.3718433,0.429046863 49.0466126,0.681623771 C47.7320357,0.934200679 46.6027666,1.68477756 45.868882,2.78039287 L30.3080791,25.7673915 L3.56828072,33.4510833 C2.98047691,33.6289295 2.43898079,33.906391 1.91530006,34.3012756 C-0.247110197,35.9873909 -0.638980173,39.1177753 1.04962319,41.2912751 L18.1351645,63.1683892 L17.194676,90.8794106 C17.1697376,91.533949 17.2730491,92.1706951 17.4867991,92.7611989 C18.423726,95.343768 21.2915027,96.6812987 23.8778449,95.7457372 L49.9977664,86.2834378 L76.1034571,95.7386257 C76.6556493,95.9413872 77.2327647,96.0445487 77.86688,96.0445487 C77.9096108,96.0445487 77.9488031,96.0445487 77.9915723,96.040991 C79.3239184,95.9983026 80.5565337,95.4362565 81.4649567,94.4615681 C82.3733798,93.4904373 82.8507644,92.220499 82.8008797,90.8936414 L81.8603798,63.1683892 L98.9708788,41.2592367 C99.3591864,40.7470059 99.6406095,40.1849675 99.8009172,39.6122368 C100.171417,38.3351984 100.021802,36.9869677 99.3769941,35.8237755 C98.7393018,34.6569679 97.6776865,33.8103525 96.3916481,33.440391 Z M67.0721884,47.533544 L52.6431124,33.4703141 C51.1885355,32.0527757 48.8280357,32.0569296 47.381805,33.4661602 L32.9319443,47.5127748 C32.2129867,48.2153132 31.818179,49.146467 31.818179,50.1358515 C31.8223367,51.1293899 32.2171405,52.0563899 32.9277905,52.7464668 C34.3740212,54.1723128 36.7428441,54.168159 38.1890748,52.7547744 L46.2514204,44.9312365 L46.2514204,65.0886929 C46.2514204,67.1173236 47.9345357,68.7718235 50.004151,68.7718235 C52.0695739,68.7718235 53.7485354,67.1173236 53.7485354,65.0886929 L53.7485354,44.9395442 L61.7901118,52.7755821 C63.2404963,54.1972744 65.6134577,54.2014282 67.0763422,52.7713898 C67.7911499,52.0730437 68.1859191,51.1418515 68.1818356,50.1524669 C68.1818356,49.1631208 67.786996,48.2319286 67.0721884,47.533544 L67.0721884,47.533544 Z"
                        id="path-1"
                      />
                    </defs>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g id="Up-Vote-Icon">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1" />
                        </mask>
                        <use id="Clip-2" fill="#32D74B" xlink:href="#path-1" />
                      </g>
                    </g>
                  </svg>
                  <!-- <button
                      v-if="item.me.vote==1"
                      class="btn btn-success op"
                      @click="vote(item.id,0)"
                  >👍</button>-->
                  <svg
                    v-else
                    @click="vote(item.id, 1, item)"
                    width="93%"
                    viewBox="0 0 100 97"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>UpVote</title>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g id="UpVote" fill="#EBEBF5" fill-rule="nonzero">
                        <path
                          d="M74.3721879,60.258774 L75.2842648,86.9536377 L49.9999971,77.8466845 L24.7157371,86.9536377 L25.6278025,60.258774 L9.09090731,39.198083 L34.9386134,31.8048142 L49.9999971,9.68093092 L65.0613808,31.8048142 L90.9090716,39.198083 L74.3721879,60.258774 Z M96.3916481,33.440391 L69.6874575,25.7673915 L54.1516123,2.81243133 C53.7846507,2.25750829 53.31442,1.7879314 52.7943046,1.45000834 C51.693497,0.702969924 50.3718433,0.429046863 49.0466126,0.681623771 C47.7320357,0.934200679 46.6027666,1.68477756 45.868882,2.78039287 L30.3080791,25.7673915 L3.56828072,33.4510833 C2.98047691,33.6289295 2.43898079,33.906391 1.91530006,34.3012756 C-0.247110197,35.9873909 -0.638980173,39.1177753 1.04962319,41.2912751 L18.1351645,63.1683892 L17.194676,90.8794106 C17.1697376,91.533949 17.2730491,92.1706951 17.4867991,92.7611989 C18.423726,95.343768 21.2915027,96.6812987 23.8778449,95.7457372 L49.9977664,86.2834378 L76.1034571,95.7386257 C76.6556493,95.9413872 77.2327647,96.0445487 77.86688,96.0445487 C77.9096108,96.0445487 77.9488031,96.0445487 77.9915723,96.040991 C79.3239184,95.9983026 80.5565337,95.4362565 81.4649567,94.4615681 C82.3733798,93.4904373 82.8507644,92.220499 82.8008797,90.8936414 L81.8603798,63.1683892 L98.9708788,41.2592367 C99.3591864,40.7470059 99.6406095,40.1849675 99.8009172,39.6122368 C100.171417,38.3351984 100.021802,36.9869677 99.3769941,35.8237755 C98.7393018,34.6569679 97.6776865,33.8103525 96.3916481,33.440391 Z M67.0721884,47.533544 L52.6431124,33.4703141 C51.1885355,32.0527757 48.8280357,32.0569296 47.381805,33.4661602 L32.9319443,47.5127748 C32.2129867,48.2153132 31.818179,49.146467 31.818179,50.1358515 C31.8223367,51.1293899 32.2171405,52.0563899 32.9277905,52.7464668 C34.3740212,54.1723128 36.7428441,54.168159 38.1890748,52.7547744 L46.2514204,44.9312365 L46.2514204,65.0886929 C46.2514204,67.1173236 47.9345357,68.7718235 50.004151,68.7718235 C52.0695739,68.7718235 53.7485354,67.1173236 53.7485354,65.0886929 L53.7485354,44.9395442 L61.7901118,52.7755821 C63.2404963,54.1972744 65.6134577,54.2014282 67.0763422,52.7713898 C67.7911499,52.0730437 68.1859191,51.1418515 68.181867,50.1524669 C68.181867,49.1631208 67.786996,48.2319286 67.0721884,47.533544 L67.0721884,47.533544 Z"
                          id="path-1"
                        />
                      </g>
                    </g>
                  </svg>

                  <!-- <button v-else class="btn btn-success op-" @click="vote(item.id,1)">👍</button> -->
                </div>
                <div
                  class="col-lg-6 offset-lg-3 col-md-10 offset-md-1 mt-md-5 mt-5"
                >
                  <svg
                    v-if="item.me.vote == -1"
                    @click="vote(item.id, 0, item)"
                    width="93%"
                    viewBox="0 0 100 97"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>Clip 2</title>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g id="Clip-2" fill="#FF453A" fill-rule="nonzero">
                        <path
                          d="M74.3721923,59.6687808 L75.2842692,86.3636462 L50,77.2566923 L24.7157385,86.3636462 L25.6278038,59.6687808 L9.09090769,38.6080885 L34.9386154,31.2148192 L50,9.09093462 L65.0613846,31.2148192 L90.9090769,38.6080885 L74.3721923,59.6687808 Z M96.3916538,32.8503962 L69.6874615,25.1773962 L54.1516154,2.22243462 C53.7846538,1.66751154 53.3144231,1.19793462 52.7943077,0.860011538 C51.6935,0.112973077 50.3718462,-0.16095 49.0466154,0.0916269231 C47.7320385,0.344203846 46.6027692,1.09478077 45.8688846,2.19039615 L30.3080808,25.1773962 L3.56828077,32.8610885 C2.98047692,33.0389346 2.43898077,33.3163962 1.9153,33.7112808 C-0.247111538,35.3973962 -0.638980769,38.5277808 1.04962308,40.7012808 L18.1351654,62.5783962 L17.1946769,90.2894192 C17.1697385,90.9439577 17.27305,91.5807038 17.4868,92.1712077 C18.4237269,94.7537769 21.2915038,96.0913077 23.8778462,95.1557462 L49.9977692,85.6934462 L76.1034615,95.1486346 C76.6556538,95.3513962 77.2327692,95.4545577 77.8668846,95.4545577 C77.9096154,95.4545577 77.9488077,95.4545577 77.9915769,95.451 C79.3239231,95.4083115 80.5565385,94.8462654 81.4649615,93.8715769 C82.3733846,92.9004462 82.8507692,91.6305077 82.8008846,90.30365 L81.8603846,62.5783962 L98.9708846,40.6692423 C99.3591923,40.1570115 99.6406154,39.5949731 99.8009231,39.0222423 C100.171423,37.7452038 100.021808,36.3969731 99.377,35.2337808 C98.7393077,34.0669731 97.6776923,33.2203577 96.3916538,32.8503962 Z M67.0721923,53.0564731 L52.6431154,67.1197077 C51.1885385,68.5372577 48.8280385,68.5331 47.3818077,67.1238654 L32.9319462,53.0772423 C32.2129885,52.3747038 31.8181808,51.44355 31.8181808,50.4541654 C31.8223385,49.4606269 32.2171423,48.5336269 32.9277923,47.84355 C34.3740231,46.4177038 36.7428462,46.4218577 38.1890769,47.8352423 L46.2514231,55.6587808 L46.2514231,35.5013192 C46.2514231,33.4727038 47.9345385,31.8182038 50.0041538,31.8182038 C52.0695769,31.8182038 53.7485385,33.4727038 53.7485385,35.5013192 L53.7485385,55.6504731 L61.7901154,47.8144346 C63.2405,46.3927423 65.6134615,46.3885885 67.0763462,47.8186269 C67.7911538,48.5169731 68.1859231,49.4481654 68.1818698,50.43755 C68.1818698,51.4268962 67.787,52.3580885 67.0721923,53.0564731 L67.0721923,53.0564731 Z"
                          id="path-1"
                        />
                      </g>
                    </g>
                  </svg>
                  <svg
                    v-else
                    @click="vote(item.id, -1, item)"
                    width="93%"
                    viewBox="0 0 100 96"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>DownVote</title>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g id="DownVote" fill="#EBEBF5" fill-rule="nonzero">
                        <path
                          d="M74.3721923,59.6687808 L75.2842692,86.3636462 L50,77.2566923 L24.7157385,86.3636462 L25.6278038,59.6687808 L9.09090769,38.6080885 L34.9386154,31.2148192 L50,9.09093462 L65.0613846,31.2148192 L90.9090769,38.6080885 L74.3721923,59.6687808 Z M96.3916538,32.8503962 L69.6874615,25.1773962 L54.1516154,2.22243462 C53.7846538,1.66751154 53.3144231,1.19793462 52.7943077,0.860011538 C51.6935,0.112973077 50.3718462,-0.16095 49.0466154,0.0916269231 C47.7320385,0.344203846 46.6027692,1.09478077 45.8688846,2.19039615 L30.3080808,25.1773962 L3.56828077,32.8610885 C2.98047692,33.0389346 2.43898077,33.3163962 1.9153,33.7112808 C-0.247111538,35.3973962 -0.638980769,38.5277808 1.04962308,40.7012808 L18.1351654,62.5783962 L17.1946769,90.2894192 C17.1697385,90.9439577 17.27305,91.5807038 17.4868,92.1712077 C18.4237269,94.7537769 21.2915038,96.0913077 23.8778462,95.1557462 L49.9977692,85.6934462 L76.1034615,95.1486346 C76.6556538,95.3513962 77.2327692,95.4545577 77.8668846,95.4545577 C77.9096154,95.4545577 77.9488077,95.4545577 77.9915769,95.451 C79.3239231,95.4083115 80.5565385,94.8462654 81.4649615,93.8715769 C82.3733846,92.9004462 82.8507692,91.6305077 82.8008846,90.30365 L81.8603846,62.5783962 L98.9708846,40.6692423 C99.3591923,40.1570115 99.6406154,39.5949731 99.8009231,39.0222423 C100.171423,37.7452038 100.021808,36.3969731 99.377,35.2337808 C98.7393077,34.0669731 97.6776923,33.2203577 96.3916538,32.8503962 Z M67.0721923,53.0564731 L52.6431154,67.1197077 C51.1885385,68.5372577 48.8280385,68.5331 47.3818077,67.1238654 L32.9319462,53.0772423 C32.2129885,52.3747038 31.8181808,51.44355 31.8181808,50.4541654 C31.8223385,49.4606269 32.2171423,48.5336269 32.9277923,47.84355 C34.3740231,46.4177038 36.7428462,46.4218577 38.1890769,47.8352423 L46.2514231,55.6587808 L46.2514231,35.5013192 C46.2514231,33.4727038 47.9345385,31.8182038 50.0041538,31.8182038 C52.0695769,31.8182038 53.7485385,33.4727038 53.7485385,35.5013192 L53.7485385,55.6504731 L61.7901154,47.8144346 C63.2405,46.3927423 65.6134615,46.3885885 67.0763462,47.8186269 C67.7911538,48.5169731 68.1859231,49.4481654 68.1819007,50.43755 C68.1819007,51.4268962 67.787,52.3580885 67.0721923,53.0564731 L67.0721923,53.0564731 Z"
                          id="path-1"
                        />
                      </g>
                    </g>
                  </svg>
                  <!-- <button
                      class="btn btn-danger op"
                      v-if="item.me.vote==-1"
                      @click="vote(item.id,0)"
                  >👎</button>-->
                  <!-- <button class="btn btn-danger op-" v-else @click="vote(item.id,-1)">👎</button> -->
                </div>
              </div>
            </div>
            <!-- </transition> -->
          </div>
        </div>

        <div
          v-if="index == Math.round(items.length / 2)"
          class="bg-muted col-12 p-0 mt-5 rounded"
        >
          <div
            class="top-text bg-dark-o py-3 py-md-5 text-center rounded border-white"
          >
            <div class="col-md-8">
              <div class="input-group mb-3">
                <div class="col-12">
                  <h4 class="text-white text-nowrap">
                    Subscribe for more topics
                  </h4>
                </div>
                <b-input-group class="mt-3">
                  <template v-slot:append>
                    <b-input-group-text
                      class="btn btn-warning"
                      @click="submitEmail"
                      >submit</b-input-group-text
                    >
                  </template>
                  <b-form-input
                    placeholder="Email"
                    v-model="email"
                    type="email"
                  ></b-form-input>
                </b-input-group>
              </div>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </transition-group>
  </div>
</template>
<script>
export default {
  props: ["items", "roomId"],
  mounted() {
    this.setTralerinItems();
  },
  data() {
    return {
      title: null,
      tsendRequest: false,
      email: "",
      videoId: "hA6hldpSTF8",
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    setTralerinItems() {
      this.items.forEach((element) => {
        this.getTreilerRequest(element.id);
      });
    },
    getTreilerRequest(id) {
      this.$http
        .get(`/v1/open-chart/${this.roomId}/movie/${id}/trailer`)
        .then((res) => {
          this.items.find((x) => x.id === id).trailer = res.data.trailer;
          console.log(res);
        });
    },
    yuotubPlayer(val) {
      this.title = val.title;
      this.videoId = val.trailer.video.split("v=")[1];
    },
    openYoutob(val) {
      window.open(val, "_blank");
    },
    submitEmail() {
      var re = /\S+@\S+\.\S+/;

      let checkRegex = re.test(String(this.email).toLowerCase());
      if (checkRegex) {
        this.$http
          .post("https://api.binj.tech/v1/newsletter/subscribe/", {
            email: this.email,
          })
          .then((res) => {
            this.$ga.event({
              eventCategory: "submit",
              eventAction: "submit",
              eventLabel: "email submission",
              eventValue: 123,
            });
            this.email = "";
            if (res.data.is_added) {
              this.$notify({
                group: "foo",
                title: "THANK YOU !",
                text: " for submit your Email !",
                color: "warning",
              });
            } else {
              this.$notify({
                group: "foo",
                title: "Oops !",
                text: " something goes wrong !",
                color: "warning",
              });
            }
          });
      } else {
        this.$notify({
          group: "foo",
          title: "Pleas check your input !",
          text: " enter valid Email",
          color: "warning",
        });
      }
    },

    vote(id, vote) {
      if (this.sendRequest) {
        // alert("waite");
      } else {
        let body = document.querySelector("body");
        body.style.opacity = 0.5;
        this.sendRequest = true;
        this.$http
          .post(
            `v1/open-chart/${this.roomId}/vote/`,
            {
              movie_id: id,
              vote: vote,
            },
            {
              headers: {
                "Binj-User": localStorage.getItem("uuid"),
              },
            }
          )
          .then((res) => {
            let changeVote = this.items.find((element) => element.id == id);
            changeVote.me.vote = vote;
            // this.items[item].me.vote = vote;
            body.style.opacity = 1;
            this.sendRequest = false;
            let value = res.data.items;

            this.$emit("sendValue", value);
          });
      }
    },
  },
};
</script>
<style >
.text-colden {
  color: gold;
}
.wahtch-trailer {
  /* width: 70%; */
  /* width: 100%;  */
  bottom: 11px;
}

.imageFather:hover .wahtch-trailer {
  bottom: 15px;
  transition: 0.2s;
}
iframe {
  width: 100%;
  max-width: 850px; /* Also helpful. Optional. */
}
#modal-1___BV_modal_footer_ {
  display: none;
}
#movie {
  min-height: 100vh;
}
button.btn-dark {
  background: rgba(0, 0, 0, 0.6);
}

.image {
  height: 100%;
  width: 100%;
}
/* .imageFather::before  {
  border-radius: 8px;
      padding: 0.5rem !important; 
      padding: 0.5rem  ;
  position: absolute;
 content: "";
  height: 100%;
  width: 100%;
background: rgb(2,0,36);
background: linear-gradient(180deg, rgba(2,0,36,0) 37%, rgba(0,7,9,1) 100%);
} */
</style>